/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Card,
  CardBody,
  Container,
  Heading,
  IconButton,
} from '@mybridge/ui';
import React, { useEffect } from 'react';
import Head from 'next/head';
import { useDispatch, useSelector } from 'react-redux';
import { getStaticPageContent } from 'v4/store/actions/global.data.actions';
import { BackArrow, BackArrowRTL } from '@mybridge/icons';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { useRouter } from 'next/router';

const SmsMessagingConsent = () => {
  const dispatch = useDispatch();
  const { pageContetStatic } = useSelector((state) => state.globalData);
  const direction = useDirection();
  const router = useRouter();

  useEffect(() => {
    dispatch(getStaticPageContent('sms-messaging-consent'));
  }, []);

  return (
    <>
      <Head>
        <title>{'SMS Messaging & Consent'} - mybridge</title>
        <meta
          name="description"
          content="myBridge - SMS Messaging Consent Policy outlines how we send SMS messages, opt-in/opt-out options, and message standard terms."
        />
        <meta
          name="keywords"
          content="SMS Messaging Consent, myBridge SMS, SMS terms, notification preferences"
        />
      </Head>
      <Container maxW="1366px" className="static-page-container">
        <Card className="static-page-body" boxShadow="none">
          <CardBody>
            <Heading as="h1" fontSize="24px" color="#3D5A80" mb={5}>
              <IconButton
                size="sm"
                variant="transparent"
                onClick={() => router.back()}
                icon={direction === 'rtl' ? <BackArrowRTL /> : <BackArrow />}
              />
              {'SMS Two-Factor Authentication (2FA) Consent'}
            </Heading>

            <Box
              className="static-page-body"
              dangerouslySetInnerHTML={{
                __html: pageContetStatic?.content,
              }}
            ></Box>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default SmsMessagingConsent;
